<template>
  <div>
    <a-spin :spinning="isLoading">
      <br />
      <div class="grid grid-cols-6">
        <div class="col-span-6 mx-8">
          <Form v-model="form" v-model:mediaType="mediaType" />
        </div>
      </div>
      <div>
        <router-link to="/tiktoks">
          <a-button>Cancel</a-button>
        </router-link>
        <a-button type="primary" @click="onSubmit" style="margin-left: 10px;"
          >Save</a-button
        >
        <a-button
          type="primary"
          @click="onSubmitAndKeep"
          style="margin-left: 10px;"
          >Save & Create other</a-button
        >
      </div>
    </a-spin>
  </div>
</template>

<script>
import Form from "@/components/Form/tiktok-form.vue";

export default {
  components: {
    Form,
  },
  data() {
    return {
      isLoading: false,
      subindustries: null,
      mediaType: "drive",
      form: {
        username: null,
        post_id: null,
        description: null,
        views: null,
        likes: null,
        shares: null,
        comments: null,
        industry: null,
        duration: null,
        music_title: null,
        download_link: null,
        tiktok_link: null,
        created_time: null,
        is_ad: null,
        new: null,
        is_free: null,
      },
    };
  },
  methods: {
    async onSubmit() {
      const { success } = await this.createTiktok();
      if (success) {
        this.$router.push("/tiktoks");
      }
    },
    async onSubmitAndKeep() {
      const { success } = await this.createTiktok();
      if (success) {
        this.$router.go(0);
      }
    },
    async createTiktok() {
      this.isLoading = true;

      const tiktok = await this.$store.dispatch("CREATE_TIKTOK", this.form);
      if (this.mediaType == "file") {
        const media = await this.uploadFile(tiktok.data.id);
        this.isLoading = false;
        return media;
      }

      this.isLoading = false;
      return tiktok;
    },
    async uploadFile(id) {
      let formdata = new FormData();
      formdata.id = id
      formdata.folder = "media"
      formdata.file = this.form.download_link
      
      formdata.append("id", id);
      formdata.append("folder", "tiktok_media");
      formdata.append("file", this.form.download_link);
      return await this.$store.dispatch("UPLOAD_TIKTOK_MEDIA", formdata);
    },
  },
};
</script>

<style>
.advertisements__new__actions button ~ button,
.advertisements__new__actions a ~ a,
.advertisements__new__actions a ~ button,
.advertisements__new__actions button ~ a {
  margin-left: 10px;
}
.custom_select--group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 10px;
}
.custom_select--group .ant-row.ant-form-item {
  margin-bottom: 0 !important;
}
</style>
